import { Component, OnInit } from '@angular/core';
import { Faq, FaqClient } from '../Services/WOWApi.Service';
import { Subscription } from 'rxjs';
import { CommonService } from '../Services/common.service';

@Component({
    selector: 'app-faqs',
    templateUrl: './faqs.component.html',
    styleUrls: ['./faqs.component.css'],
    standalone: false
})
export class FaqsComponent implements OnInit {
faqs:Faq[];
showSpinner:boolean = false;
isMobileView = false;
subscription: Subscription;
  constructor(
    private _faqClient:FaqClient,
    private commonService: CommonService
  ) { 
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
  }

  ngOnInit(): void {
    this.showSpinner = true;
    this._faqClient.getFaqs().subscribe(faq => {
      this.faqs = (faq || []).map(item => {
        item.answer = this.rewriteContactLinks(item.answer);
        return item;
      });
      this.showSpinner = false;
    }, error => { this.showSpinner = false; });
  }

  private rewriteContactLinks(html: string | undefined): string | undefined {
    if (!html) {
      return html;
    }
    return html
      .replace(/https?:\/\/localhost:4200\/faqs\/?/gi, 'https://lootlucky.com/Contact')
      .replace(/https?:\/\/(www\.)?lootlucky\.com\/faqs\/?/gi, 'https://lootlucky.com/Contact');
  }

}
